/** @jsxRuntime classic */
/** @jsx jsx */
import dedent from 'dedent';
import { useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { BlockNoteView, useCreateBlockNote } from '@blocknote/react';
import { ANALYSIS_BLOCKS } from './blocks/blocks';

import Text from '@mui/material/Typography';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

const TEMPLATES = {
  interview: dedent`## {{title}}

  ### lt('Sammanfattning')

  {{summary}}

  ### lt('Frågor och svar')

  {{qa}}`,
  meeting: dedent`## {{title}}

  ### lt('Sammanfattning')

  {{summary}}

  ### lt('Uppföljning')

  {{actionPoints}}`,
  summary: dedent`## {{title}}

  ### lt('Sammanfattning')

  {{summary}}`,
  empty: '',
};

export default function CreateDocumentPreview({ meeting, template }) {
  const { t } = useTranslation();
  const editor = useCreateBlockNote();

  useEffect(() => {
    (async () => {
      let markdown =
        template in TEMPLATES
          ? TEMPLATES[template]
          : t('Inget exempel tillgängligt');
      // Find all variables and replace them with text key from ANALYSIS_BLOCKs
      markdown = markdown.replace(/lt\('([^']+)'\)/g, (_, key) => t(key));
      const variables = markdown.match(/{{[a-zA-Z0-9_\-]+}}/g) || [];
      variables.forEach((variable) => {
        let key = variable.replace(/{{|}}/g, '');
        if (key === 'summary') key = 'summaryShort';
        if (key === 'title') {
          markdown = markdown.replace(variable, t(`Beskrivning av Klang AI`));
        } else {
          const block = ANALYSIS_BLOCKS.find((block) => block.type === key);
          if (block) {
            markdown = markdown.replace(variable, block.example);
          }
        }
      });
      const blocks = await editor.tryParseMarkdownToBlocks(markdown);
      editor.replaceBlocks(editor.document, blocks);
    })();
  }, [template]);

  return (
    <div
      css={css`
        background: #fff;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        padding: 1rem;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        flex: 1;
        border-radius: 8px;
      `}
    >
      <Text
        variant="subtitle1"
        gutterBottom
        css={css`
          display: flex;
          align-items: center;
          gap: 0.5rem;
        `}
      >
        <TextSnippetIcon css={{ color: '#0000008A' }} />
        {t('Exempel')}
      </Text>
      <BlockNoteView
        css={css`
          max-height: 534px;
          overflow-y: auto;
          .bn-editor {
            padding-inline: 0;
          }
        `}
        editor={editor}
        editable={false}
        theme="light"
      />
    </div>
  );
}
